import React from 'react';
import UseBktGrid from '../UseBktGrid';
import LoadSpinnerOverlay from '../LoadSpinner';
import { ModalContentWrapper } from './styles';

// TODO: Ideally this should be done by backend.
const addIDForDataUsedForBktGrid = data => data.map((datum, i) => ({ id: i, ...datum }));

const ScenarioCompareSummaryModal = ({
  dataViewForSummary,
  gridConfigForData,
}) => (
  <ModalContentWrapper height="70vh" width="inherit">
    <LoadSpinnerOverlay
      spinning={dataViewForSummary.loadingQueue.length > 0}
      width="100%"
    />
    {
      (
        dataViewForSummary.loadingQueue.length === 0
        && dataViewForSummary.data.data
      ) && (
        <UseBktGrid
          data={addIDForDataUsedForBktGrid(dataViewForSummary.data.data)}
          config={gridConfigForData}
        />
      )
    }
  </ModalContentWrapper>
);

export default ScenarioCompareSummaryModal;
